import React from "react";
import { useSelector } from "react-redux";

// Укорачиваем большие числа до K, M, B
const formatNumberShort = (n) => {
    const num = Number(n);
    if (isNaN(num)) return "0";
    if (num >= 1e9) return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    return num.toString();
};

export default function PromoWinners() {
    const promoForm = useSelector((state) => state.promoForm);
    const { participantsCount, prizePlacesCount } = promoForm;
    const nonWinners = participantsCount - prizePlacesCount;

    const winnersPercent =
        participantsCount > 0
            ? ((prizePlacesCount / participantsCount) * 100).toFixed(1)
            : "0";
    const nonWinnersPercent =
        participantsCount > 0
            ? ((nonWinners / participantsCount) * 100).toFixed(1)
            : "0";

    return (
        <div className="mt-4 flex h-[80px] w-full flex-row items-center justify-center gap-7 rounded-xl border border-white/10 bg-white/[0.03] backdrop-blur-sm">
            {/* Participants */}
            <div className="flex w-[80px] flex-col items-center justify-center gap-1">
                <div className="text-[10px] font-thin text-white/45">participants</div>
                <div className="flex h-[30px] w-full items-center justify-center rounded-2xl border border-white/10 bg-white/[0.06]">
                    {formatNumberShort(participantsCount)}
                </div>
                <div className="text-[10px] font-thin text-white/40">100%</div>
            </div>

            {/* Winners */}
            <div className="flex w-[80px] flex-col items-center justify-center gap-1">
                <div className="text-[10px] font-thin text-white/45">winners</div>
                <div className="flex h-[30px] w-full items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04]">
                    {formatNumberShort(prizePlacesCount)}
                </div>
                <div className="text-[10px] font-thin text-white/40">{winnersPercent}%</div>
            </div>

            {/* Non-winners */}
            <div className="flex w-[80px] flex-col items-center justify-center gap-1">
                <div className="text-[10px] font-thin text-white/45">non-winners</div>
                <div className="flex h-[30px] w-full items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04]">
                    {formatNumberShort(nonWinners)}
                </div>
                <div className="text-[10px] font-thin text-white/40">{nonWinnersPercent}%</div>
            </div>
        </div>
    );
}
